import React, { useState, useEffect } from 'react';
import { Route, Routes, BrowserRouter as Router, useNavigate } from 'react-router-dom';
import NavBar from './components/NavBar';
import SignUp from './components/Signup';
import Login from './components/Login';
import Slideshow from './components/Slide';
import Teams from './components/Team';
import MyTeam from './components/Myteam';
import About from './components/About';
import MyArmy from './components/MyArmy';

const images = [
  'https://img.freepik.com/free-photo/futuristic-robot-interacting-with-money_23-2151612708.jpg?size=626&ext=jpg',
  'https://img.freepik.com/free-photo/robotic-human-heart-futuristic-representation_23-2151681149.jpg?size=626&ext=jpg',
  'https://img.freepik.com/free-photo/robotic-human-heart-futuristic-representation_23-2151681151.jpg?size=626&ext=jpg',
  'https://img.freepik.com/free-photo/3d-rendering-biorobots-concept_23-2149524398.jpg?size=626&ext=jpg'
];

function App() {
  return (
    <Router>
      <Main />
    </Router>
  );
}

function Main() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showForm, setShowForm] = useState('');
  const [authenticated, setAuthenticated] = useState(false);
  const [authenticatedUser] = useState('')

  const navigate = useNavigate();

  useEffect(() => {
    if (showForm === '' && !authenticated) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
      }, 7000);

      return () => clearInterval(interval);
    }
  }, [showForm, authenticated]);

  const handleShowForm = (formType) => {
    setShowForm(formType);
  };

  const handleAuthentication = (status) => {
    setAuthenticated(status);
    setShowForm('');
    navigate('/'); 
  };

  const handleLogout = () => {
    setAuthenticated(false);
    alert('Are you sure you want to logout?');
    setShowForm('');
    navigate('/'); 
  };

  return (
    <>
      <NavBar authenticated={authenticated} onLinkClick={handleShowForm} onLogout={handleLogout} />
      <Routes>
        <Route
          path="/"
          element={
            showForm === '' ? <Slideshow currentIndex={currentIndex} images={images} /> : null
          }
        />
        <Route
          path="/signup"
          element={<SignUp onAuthenticate={() => handleAuthentication(true)} />}
        />
        <Route
          path="/login"
          element={<Login onAuthenticate={() => handleAuthentication(true)} />}
        />
        <Route
          path="/teams"
          element={<Teams />}
        />
        <Route
          path="/myteam"
          element={<MyTeam currentUser={authenticatedUser} />
        }
        />
        <Route
          path="/about"
          element={<About />}
        />
        
          
          <Route 
            path="/my-army" 
            element={<MyArmy />} />
      </Routes>
    </>
  );
}

export default App;
